import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Loader from "./Loader";

const Wrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  height: ${(props) =>
    !props.height ? "4.8rem" : props.height ?? "fit-content"};
  width: ${(props) =>
    props.fullWidth ? "100%" : props.width ?? "fit-content"};
  padding: 0 1.6rem;
  background-color: ${(props) => props.bg ?? "var(--primary)"};
  color: ${(props) => (props.color ? props.color : "#ffffff")};
  border: ${(props) => (props.bd ? `1px solid ${props.bd}` : null)};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: center;
  transition: var(--transition_default);

  .icon {
    height: 2rem;
    margin-right: 1.2rem;
  }

  .endIcon {
    height: 2rem;
    margin-left: 1.2rem;
    cursor: pointer;
  }

  &:not([disabled]):hover {
    background-color: var(--primary_light);
    color: #ffffff;
  }

  &.bordered {
    border: 1px solid var(--secondary);
    color: var(--secondary);
    background-color: transparent;
  }

  &.borderedPrimary {
    border: 1px solid var(--primary);
    color: var(--primary);
    background-color: transparent;
  }

  &.borderedGrey {
    border: 1px solid var(--body_text);
    color: var(--body_text);
    background-color: transparent;
  }

  &.borderedDanger {
    border: 1px solid var(--danger);
    color: var(--danger);
    background-color: transparent;
  }

  &.noBorder {
    border: none;
    color: ${(props) => (props.color ? props.color : "var(--primary)")};
    background-color: transparent;
  }
`;

const Button = ({
  className,
  bg,
  type,
  height,
  fullWidth,
  width,
  text,
  disabled,
  color,
  icon,
  endIcon,
  bd,
  as,
  href,
  onClick,
  loading,
}) => {
  const styleProps = {
    className,
    bg,
    type,
    height,
    fullWidth,
    width,
    text,
    disabled,
    color,
    bd,
    as,
    href,
    onClick,
  };

  if (loading) {
    return (
      <Wrapper {...styleProps}>
        <Loader type="spinner" />
      </Wrapper>
    );
  }

  return (
    <Wrapper {...styleProps}>
      {icon && <img src={icon} alt="icon" className="icon" />}
      <span>{text}</span>
      {endIcon && <img src={endIcon} alt="endIcon" className="endIcon" />}
    </Wrapper>
  );
};

Button.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  bg: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  fullWidth: PropTypes.bool,
  icon: PropTypes.string,
  endIcon: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
};

export default Button;
